module.exports = __webpack_public_path__ + "assets/vote_icon__gray.14e2ab89.svg";